import type { FormInstance, FormProps } from './const';
import { Form as ArcoForm } from '@arco-design/web-react';
import { cn } from '@utils';
import { forwardRef } from 'react';
import './index.less';

function Form(props: FormProps, ref: React.Ref<FormInstance>) {
  const { children, className, ...restProps } = props;

  return (
    <ArcoForm
      ref={ref}
      className={cn('wg-form', className)}
      {...restProps}
    >
      {children}
    </ArcoForm>
  );
}

const FormWithRef = forwardRef<FormInstance, FormProps>(Form);

FormWithRef.displayName = 'Form';

// 保留 ArcoForm 的静态属性和方法
const FormComponent = FormWithRef as unknown as typeof ArcoForm & {
  displayName?: string;
};

FormComponent.Item = ArcoForm.Item;
FormComponent.List = ArcoForm.List;
FormComponent.Control = ArcoForm.Control;
FormComponent.Provider = ArcoForm.Provider;
FormComponent.useForm = ArcoForm.useForm;
FormComponent.useFormContext = ArcoForm.useFormContext;
FormComponent.useWatch = ArcoForm.useWatch;
FormComponent.useFormState = ArcoForm.useFormState;

export default FormComponent;

export type { FormInstance, FormProps };
